
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // 1. Check file input
        const fileInput = this.querySelector('#custom-file-upload');
        if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
          alert('Please upload a file before adding to cart.');
          this.submitButton.disabled = true;
          this.submitButton.classList.add('disabled');
          fileInput?.focus();
          return;
        }
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];


        const form = this.form;
        const productVariantId = form.querySelector('[name="id"]')?.value;
        const productId = Shopify.currentProductId;
        
        fetch('/cart.js')
          .then(res => res.json())
          .then(async (existingCart) => {
            const existingItem = existingCart.items.find(item => item.product_id == parseInt(productId));

            debugger;
            if (existingItem) {

              // Step 2: Find the main product's key and its setup fee key
              let mainItemKey = null;
              let setupFeeItemKey = null;
        
              for (const item of existingCart.items) {
                const isMainItem = 
                  item.variant_id == existingItem.id && !item.properties?._product_variant_id;
        
                const isSetupFee = 
                  item.handle === 'setup-fee' && item.properties?._product_variant_id == existingItem.id;
        
                if (isMainItem) {
                  mainItemKey = item.key;
                }
        
                if (isSetupFee) {
                  setupFeeItemKey = item.key;
                }
              }
        
              // Step 3: Remove the main item by key (if found)
              if (mainItemKey) {
                await fetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                  },
                  body: JSON.stringify({
                    id: mainItemKey,
                    quantity: 0,
                  }),
                });
              }
        
              // Step 4: Remove the setup fee item by key (if found)
              if (setupFeeItemKey) {
                await fetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                  },
                  body: JSON.stringify({
                    id: setupFeeItemKey,
                    quantity: 0,
                  }),
                });
              }
            }
            
      
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            // --- START: Add Setup Fee Product ---
            const setupFeeVariantId = '50431673598232'; // <-- replace with your actual Setup Fee variant ID
            const productVariantId = formData.get('id');
            
            // Get the current cart and check if setup fee for this product is already there
            fetch('/cart.js')
              .then(res => res.json())
              .then(async (cart) => {
                const alreadyExists = cart.items.some(item => {
                  return (
                    item.variant_id === parseInt(setupFeeVariantId) &&
                    item.properties &&
                    item.properties['_product_variant_id'] == productVariantId
                  );
                });
            
                if (!alreadyExists) {
                  await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({
                      id: setupFeeVariantId,
                      quantity: 1,
                      properties: {
                        '_product_variant_id': productVariantId,
                        'Product': document.querySelector('.product__title h1')?.textContent || ''
                      }
                    })
                  });
                }
                window.location.href = "/cart";
              });
            // --- END: Add Setup Fee Product ---


            return;
            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
       });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

  document.addEventListener('DOMContentLoaded', function () {
    const button = document.getElementById('popara');
    const popic = document.querySelector('.popic');
    const closeButton = document.getElementById('close');

    // Function to toggle the 'vis' class
    function togglePopic() {
        popic.classList.toggle('vis');
    }

    // Function to close the 'popic' by removing 'vis' class
    function closePopic() {
        popic.classList.remove('vis');
    }

    // Toggle class on button click
    button.addEventListener('click', function (event) {
        event.stopPropagation();
        togglePopic();
    });

    // Close on clicking the close button
    closeButton.addEventListener('click', function (event) {
        event.stopPropagation();
        closePopic();
    });

    // Close on clicking outside of 'popic'
    document.addEventListener('click', function (event) {
        if (!popic.contains(event.target) && !button.contains(event.target)) {
            closePopic();
        }
    });

    // Prevent propagation when clicking inside 'popic'
    popic.addEventListener('click', function (event) {
        event.stopPropagation();
    });
});


document.addEventListener('DOMContentLoaded', function () {
  const fileInput = document.getElementById('custom-file-upload');
  const atcButton = document.querySelector('form[action*="/cart/add"] [type="submit"]');
  const label = document.querySelector('label[for="custom-file-upload"]');

  const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/svg+xml'];

  if (atcButton && fileInput && label) {
    atcButton.disabled = true;
    atcButton.classList.add('disabled');

    fileInput.addEventListener('change', function () {
      const file = fileInput.files[0];

      if (file && allowedTypes.includes(file.type)) {
        atcButton.disabled = false;
        atcButton.classList.remove('disabled');
        label.classList.add('file-selected');
      } else {
        // Reset input
        fileInput.value = '';
        atcButton.disabled = true;
        atcButton.classList.add('disabled');
        label.classList.remove('file-selected');

        alert('Please upload a valid image file (JPG, PNG, WebP, SVG).');
      }
    });
  }
});



